import { CastType } from '@/types/casts'
import { Cast } from '../classes'
import { CastSwitcher } from '../classes/CastSwitcher'
import { CastStationSwitcher } from '../classes/CastStationSwitcher'
import { CastFanRoom } from '../classes/CastFanRoom'

export const isSwitcherCast = (cast: Cast|null): cast is CastSwitcher => {
  return cast?.castType === CastType.Switcher
}

export const isStationSwitcherCast = (cast: Cast|null): cast is CastStationSwitcher => {
  return cast?.castType === CastType.StationSwitcher
}

export const isFanRoomCast = (cast: Cast|null): cast is CastFanRoom => {
  return cast?.castType === CastType.FanRoom
}

